module.exports = __webpack_public_path__ + "img/jackpot.3013e539.png";